'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = getReferencesSaga;

var _effects = require('redux-saga/effects');

var _selectSession = require('../../selectors/context/selectSession');

var _selectReferences = require('../../selectors/reference/selectReferences');

var _reduceReferences = require('../../actions/reference/reduceReferences');

var _reduceReferences2 = _interopRequireDefault(_reduceReferences);

var _selectSubfolderPrefix = require('../../selectors/context/selectSubfolderPrefix');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getReferencesSaga);

function getReferencesSaga(_ref) {
	var payload = _ref.payload;
	var session, references, subfolderPrefix, endpoint, headers, response, result;
	return regeneratorRuntime.wrap(function getReferencesSaga$(_context) {
		while (1) {
			switch (_context.prev = _context.next) {
				case 0:
					_context.prev = 0;
					_context.next = 3;
					return (0, _effects.select)((0, _selectSession.selectSession)());

				case 3:
					session = _context.sent;
					_context.next = 6;
					return (0, _effects.select)((0, _selectReferences.selectReferences)());

				case 6:
					references = _context.sent;
					_context.next = 9;
					return (0, _effects.select)((0, _selectSubfolderPrefix.selectSubfolderPrefix)());

				case 9:
					subfolderPrefix = _context.sent;
					endpoint = subfolderPrefix + '/api/reference/references';

					if (payload.custom) {
						endpoint = subfolderPrefix + '/api/reference/custom-references';
					}

					if (references[payload.code]) {
						_context.next = 24;
						break;
					}

					headers = {
						'Accept': 'application/json',
						'Content-Type': 'application/json'
					};


					if (session && session.authenticationToken && session.authenticationToken.token && session.authenticationToken.token !== 'undefined') {
						headers['Authorization'] = session.authenticationToken.token;
					}

					_context.next = 17;
					return (0, _effects.call)(fetch, endpoint, {
						method: 'POST',
						credentials: 'same-origin',
						headers: headers,
						body: JSON.stringify({
							referenceDefinition: {
								code: payload.custom ? payload.code : payload,
								effectiveDate: new Date()
							}
						})
					});

				case 17:
					response = _context.sent;
					_context.next = 20;
					return (0, _effects.call)([response, 'json']);

				case 20:
					result = _context.sent;

					if (!result.operation.status) {
						_context.next = 24;
						break;
					}

					_context.next = 24;
					return (0, _effects.put)((0, _reduceReferences2.default)({
						code: result.referenceDefinition.code,
						value: result.referenceDefinition.references
					}));

				case 24:
					_context.next = 29;
					break;

				case 26:
					_context.prev = 26;
					_context.t0 = _context['catch'](0);

					console.error('An error occurred:', _context.t0);

				case 29:
				case 'end':
					return _context.stop();
			}
		}
	}, _marked, this, [[0, 26]]);
}